import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { lacUserService } from '../../../services/LacUserService';
import { lacQueryKeys } from '../lacQueryKeys';

export function useLacUsersByTenantQuery() {
  const { user } = useAuth();

  return useQuery({
    queryKey: lacQueryKeys.usersByTenant(),
    enabled: Boolean(user),
    queryFn: () => lacUserService.listUsersByTenant(),
  });
}
